/* eslint-disable @typescript-eslint/no-unsafe-return,
  no-unused-expressions, @typescript-eslint/no-unused-expressions,
  @typescript-eslint/await-thenable */
import React from 'react';
import { ButtonActionEmphasis, sanitize } from '@honeycomb-npm/honeycomb-react';
import { bindActionCreators } from 'redux';
import { useSelector, useDispatch } from 'react-redux';
import { content } from '../../utils/contentUtils';
import { isNetbankCustomer } from '../../utils/customerTypeUtils';
import { customerData } from '../../utils/customerDataUtils';
import SuccessPage from '../SuccessPage/SuccessPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import { actionCreators, State } from '../../redux';
import Loader from '../Shared/Loader/Loader';
import constants from '../../constants';

const Pages = () => {
  const dispatch = useDispatch();
  const isNetBankUser = isNetbankCustomer;
  const { netBankCustomers: netBankContent, allCustomers: allCustomerContent, callToAction: callToActionContent } = content;
  const userData = customerData;
  const appContent = isNetBankUser ? netBankContent : allCustomerContent;
  const { submitForm } = bindActionCreators(actionCreators, dispatch);
  const { AnalyticsConstants } = constants;
  const { unsubscribeAllCustomer, unsubscribeNetbankCustomer } = AnalyticsConstants;
  const unsubscribeAnalyticsId = isNetBankUser ? unsubscribeNetbankCustomer : unsubscribeAllCustomer;
  const {
    isLoading,
    isFormVisible,
    isSuccess,
    isFailure,
  } = useSelector((state: State) => state.mainReducer);

  const formSubmit = () => {
    submitForm(userData);
  };

  return (
    <div className="col-12 px-3 px-md-8 px-sm-6 pb-6">
      <hr />
      {isFormVisible && (
        <div className="row mx-0">
          <div className="col-lg-9 col-sm-12 px-0">
            <h2>{appContent.unsubscribeTitle}</h2>
            <div className="mt-2" dangerouslySetInnerHTML={sanitize(appContent.unsubscribeDisclaimer)} />
            <div className="mt-2" dangerouslySetInnerHTML={sanitize(appContent.unsubscribeDisclaimerForOtherEmails)} />
            <div className="mt-2" dangerouslySetInnerHTML={sanitize(appContent.managePreferencesDisclaimer)} />
            <div className="my-4">
              <ButtonActionEmphasis
                id={unsubscribeAnalyticsId}
                onClick={formSubmit}
              >
                {callToActionContent.unsubscribeBtn.displayText}
              </ButtonActionEmphasis>
            </div>
          </div>
        </div>
      )}
      {isLoading && (<Loader />)}
      {isSuccess && (<SuccessPage />)}
      {isFailure && (<ErrorPage />)}
    </div>
  );
};

export default Pages;
